import type { FunctionParameter } from '../fns';

export const params_file_transfer: Record<number, FunctionParameter[]> = {
  0x01: [
    {
      name: 'file_type',
      type: 'u8',
      bytes: 1,
      comment: '[0]: Datalog, [1]: Eventlog, [2]: Cal/Bump log, [3]: sensor config data',
      format: 'enum_mini_file_type',
    },
    {
      name: 'transfer_mode',
      type: 'u8',
      bytes: 1,
      comment: '[0]: Normal mode, [1]: Burst mode, datalog only',
      format: 'enum_transfer_mode',
    },
  ],
  0x02: [
    {
      name: 'file_type',
      type: 'u16',
      bytes: 2,
      comment: '[0]: Datalog, [1]: Eventlog, [2]: Cal/Bump log, [3]: sensor config data',
      format: 'enum_mini_file_type',
    },
    {
      name: 'version',
      type: 'u16',
      bytes: 2,
      comment: 'Structure version, it can be used to decide how to parse log data',
      format: 'version',
    },
    {
      name: 'chunk_size',
      type: 'u16',
      bytes: 2,
      comment: 'Chunk(MTU) size (bytes)',
      format: 'number',
    },
    {
      name: 'num_packets',
      type: 'u16',
      bytes: 2,
      comment: 'number of requests',
      format: 'number',
    },
    {
      name: 'total_size',
      type: 'u32',
      bytes: 4,
      comment: 'Total size of file',
      format: 'number',
    },
  ],
  0x03: [
    {
      name: 'datalog_chunk_index',
      type: 'u16',
      bytes: 2,
      comment:
        'Depends on data log size in NOR flash map (max num = 96kB / chunk size 512byte), max num: 192 (0~191)',
      format: 'number',
    },
  ],
  0x04: [
    {
      name: 'datalog_chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Depends on request',
      format: 'number',
    },
    {
      name: 'datalog_chunk',
      type: 'au8[]',
      bytes: 512,
      comment: 'Max Payload size - other data',
      format: 'binary',
    },
  ],
  0x05: [
    {
      name: 'eventlog_chunk_index',
      type: 'u16',
      bytes: 2,
      comment:
        'Depends on eventlog size in EEPROM Map (max num = 4kB / chunk size 512Byte), max num: 8 (0~7)',
      format: 'number',
    },
  ],
  0x06: [
    {
      name: 'eventlog_chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Depends on request',
      format: 'number',
    },
    {
      name: 'eventlog_chunk',
      type: 'au8[]',
      bytes: 512,
      comment: 'Max Payload size - other data',
      format: 'binary',
    },
  ],
  0x07: [
    {
      name: 'eventlog_chunk_index',
      type: 'u16',
      bytes: 2,
      comment:
        'Depends on eventlog size in EEPROM Map (max num = 768B / chunk size 512Byte), max num: 2 (0~1)',
      format: 'number',
    },
  ],
  0x08: [
    {
      name: 'eventlog_chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Depends on request',
      format: 'number',
    },
    {
      name: 'eventlog_binary',
      type: 'au8[]',
      bytes: 512,
      comment: 'Max Payload size - other data',
      format: 'binary',
    },
  ],
  0x09: [
    {
      name: 'eventlog_chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Depends on request, max num: 18 (0~17)',
      format: 'number',
    },
  ],
  0x0a: [
    {
      name: 'eventlog_chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Depends on request',
      format: 'number',
    },
    {
      name: 'eventlog_binary',
      type: 'au8[]',
      bytes: 512,
      comment: 'Max Payload size - other data',
      format: 'binary',
    },
  ],
  0x10: [
    {
      name: 'header_crc',
      type: 'u16',
      bytes: 2,
      comment: 'CRC of header',
      format: 'number',
    },
    {
      name: 'file_type',
      type: 'u8',
      bytes: 1,
      comment: '[0]: Firmware, [1]: Sensor data, [2]: Settings',
      format: 'enum_sensor_data_type',
    },
    {
      name: 'version',
      type: 'au8[]',
      bytes: 3,
      comment: 'Major, minor, patch. In case of sensor data, only major is used.',
      format: 'version',
    },
    {
      name: 'file_crc',
      type: 'u16',
      bytes: 2,
      comment: 'CRC of file to send',
      format: 'number',
    },
    {
      name: 'chunk_size',
      type: 'u16',
      bytes: 2,
      comment: 'Chunk(MTU) size (bytes) per each index',
      format: 'number',
    },
    {
      name: 'num_packets',
      type: 'u16',
      bytes: 2,
      comment: 'number of requests',
      format: 'number',
    },
    {
      name: 'total_size',
      type: 'u32',
      bytes: 4,
      comment: 'Total size of file',
      format: 'number',
    },
  ],
  0x11: [
    {
      name: 'file_type',
      type: 'u8',
      bytes: 1,
      comment: '[0]: Firmware, [1]: Sensor data, [2]: Settings',
      format: 'enum_sensor_data_type',
    },
  ],
  0x12: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Depends on FW or sensor data update request',
      format: 'number',
    },
    {
      name: 'chunk_data',
      type: 'au8[]',
      bytes: 512,
      comment: 'Max Payload size - other data',
      format: 'binary',
    },
  ],
  0x13: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Depends on FW or sensor data update request',
      format: 'number',
    },
  ],
  0x14: [
    {
      name: 'file_type',
      type: 'u8',
      bytes: 1,
      comment: '[0]: Firmware, [1]: Sensor data, [2]: Settings',
      format: 'enum_sensor_data_type',
    },
    {
      name: 'version',
      type: 'au8[]',
      bytes: 3,
      comment: 'Structure version, it can be used to decide how to handle data',
      format: 'version',
    },
  ],
  0x15: [
    {
      name: 'result',
      type: 'u8',
      bytes: 1,
      comment: '[0]: Fail, [1]: Start to FW or sensor data update',
      format: 'bool',
    },
  ],
  0x16: [],
  0x17: [
    {
      name: 'result',
      type: 'u8',
      bytes: 1,
      comment: '[0]: Fail, [1]: Stopped burst transfer of log data',
      format: 'bool',
    },
  ],
  0x18: [
    {
      name: 'datalog_chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'datalog chunk index',
      format: 'number',
    },
    {
      name: 'datalog_chunk',
      type: 'au8[]',
      bytes: 512,
      comment: 'Max Payload size - other data',
      format: 'binary',
    },
  ],
};
